/* eslint-disable */
import { MODAL_TOGGLE, MODAL_HIDE } from '../constants/actionTypes';

export const modalsToggle = data => ({ type: MODAL_TOGGLE, payload: data });

export const modalsHide = data => ({ type: MODAL_HIDE, payload: data });
